import { STEPS } from "../nova-data";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export function NovaHowItWorks() {
  const { ref: headerRef, visible: headerVisible } = useScrollReveal(0.1);
  const { ref: stepsRef, visible: stepsVisible } = useScrollReveal(0.1);

  return (
    <section className="max-w-[1200px] mx-auto px-6 pb-20">
      <div
        ref={headerRef}
        className="text-center mb-12 transition-all duration-700"
        style={{
          opacity: headerVisible ? 1 : 0,
          transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
        }}
      >
        <h2 className="text-4xl font-bold text-white mb-3 font-roboto">Πώς λειτουργεί;</h2>
        <p className="text-white/50 text-lg">Τρία απλά βήματα για να αρχίσεις να κερδίζεις.</p>
      </div>
      <div ref={stepsRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {STEPS.map((step, i) => (
          <div
            key={step.number}
            className="relative flex flex-col items-center text-center transition-all duration-700"
            style={{
              opacity: stepsVisible ? 1 : 0,
              transform: stepsVisible ? 'translateY(0)' : 'translateY(40px)',
              transitionDelay: `${i * 120}ms`,
            }}
          >
            {i < STEPS.length - 1 && (
              <div className="hidden md:block absolute top-8 left-[calc(50%+2rem)] right-[-calc(50%-2rem)] h-px bg-gradient-to-r from-[#00d9d9]/40 to-transparent" />
            )}
            <div className="w-16 h-16 rounded-2xl border border-[#00d9d9]/30 bg-[#00d9d9]/10 flex items-center justify-center mb-4">
              <span className="text-[#00d9d9] font-bold text-lg font-press-start">{step.number}</span>
            </div>
            <h3 className="text-white font-semibold text-lg mb-2">{step.title}</h3>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
